const env = process.env;

/**
 * 富士通環境設定
 */
export const FJ_ENV = env.VUE_APP_FJ_ENV;
export enum FjEnv {
  Dev = "dev",
  Stg = "stg",
}

/**
 * 画面
 */
export const VIEW_CONFIG = {
  SP_MAX_WIDTH: 767,
};

/**
 * API設定
 */
export const API_CONFIG = {
  BASE_URL: env.VUE_APP_API_BASE_URL,
  TIMEOUT: 30000,
  ENCODING: "UTF-8",
  CONTENT_TYPE: "application/json",
};

/**
 * APIエラーメッセージ
 */
export const API_ERROR_MESSAGE = {
  TIMEOUT: "message.Const.api_error_message.timeout",
  NETWORK: "message.Const.api_error_message.network",
  UNKNOWN: "message.Const.api_error_message.unknown",
  NO_METHOD: "message.Const.api_error_message.no_method",
  NOT_FOUND: "message.Const.api_error_message.not_found",
  FAILED_GENERAL: "message.Const.api_error_message.failed_general",
  FAILED_TO_GET: "message.Const.api_error_message.failed_to_get",
};

/**
 * サービスメニュー
 */
export enum ServiceMenuStatusIconType {
  Explanation = 0,
  InSummary = 1,
  InLine = 2,
  EventDetail = 3,
}

export enum ServiceMenuStatus {
  Ok = 0,
  Warning = 1,
  Error = 2,
  Notification = 3,
  Maintenance = 4,
}

export enum ServiceMenuType {
  PortalSite = 1,
  Event = 0,
}

export const SERVICE_MENU_STATUS_NAME: { [key in ServiceMenuStatus]: string } =
  {
    [ServiceMenuStatus.Ok]: "message.Const.service_menu_status_name.ok",
    [ServiceMenuStatus.Warning]:
      "message.Const.service_menu_status_name.warning",
    [ServiceMenuStatus.Error]: "message.Const.service_menu_status_name.error",
    [ServiceMenuStatus.Notification]:
      "message.Const.service_menu_status_name.notification",
    [ServiceMenuStatus.Maintenance]:
      "message.Const.service_menu_status_name.maintenance",
  };

export const SERVICE_MENU_STATUS_SUMMARY_TEXT: {
  [key in ServiceMenuStatus]: string;
} = {
  [ServiceMenuStatus.Ok]: "message.Const.service_menu_status_summary_text.ok",
  [ServiceMenuStatus.Warning]:
    "message.Const.service_menu_status_summary_text.warning",
  [ServiceMenuStatus.Error]:
    "message.Const.service_menu_status_summary_text.error",
  [ServiceMenuStatus.Notification]:
    "message.Const.service_menu_status_summary_text.notification",
  [ServiceMenuStatus.Maintenance]:
    "message.Const.service_menu_status_summary_text.maintenance",
};

export const SERVICE_MENU_STATUS_SUMMARY_TEXT_OTHER = {
  // NO_OTHERS: "お知らせ・メンテナンスなし",
  // ALL_OTHERS: "お知らせ・メンテナンスあり",
  NO_OTHERS: "message.Const.service_menu_status_summary_text_other.no_others",
  ALL_OTHERS: "message.Const.service_menu_status_summary_text_other.all_others",
  WARNING_ERROR:
    "message.Const.service_menu_status_summary_text_other.warning_error",
};

/**
 * イベント
 */
export enum CurrentFlag {
  On = 1, // 現在のイベント
  Off = 0, // 過去のイベント
}

/**
 * 言語コード
 */
export const LANGUAGE_OPTIONS = {
  EN: {
    TEXT: "English",
    VALUE: "en",
  },
  JA: {
    TEXT: "日本語",
    VALUE: "ja",
  },
};

/**
 * localStorageのキー
 */
export const LOCALSTORAGE_KEY = {
  LANG: "lang",
};

/**
 * その他画面
 */
export const OTHER_INFO = {
  FUJITSU_SITE_URL: "https://www.fujitsu.com/jp/",
  ABOUT_THIS_SITE_URL: "https://www.fujitsu.com/jp/about/resources/terms/",
  PRIVACY_POLICY_URL: "https://www.fujitsu.com/jp/about/resources/privacy/",
  SUPPORT_URL: "https://www.fujitsu.com/jp/support/index.html",
  FOOTER_FACEBOOK_URL: "https://www.facebook.com/FujitsuOfficial",
  FOOTER_TWITTER_URL:
    "https://twitter.com/intent/follow?source=followbutton&variant=1.0&screen_name=FujitsuOfficial",
  FOOTER_YOUTUBE_URL:
    "https://www.youtube.com/user/FujitsuOfficial?sub_confirmation=1",
  FOOTER_LINKEDIN_URL: "https://www.linkedin.com/company/fujitsujapan/",
};
